import React from 'react';

const DesignStep = ({ formData, handleOptionSelect }) => {
    // Prices for different orbital styles
    const orbitalPrices = {
        'Stellar Simplicity': 'Basic',
        'Orbit': '€ 5.00',
        'Constellation Frame': '€ 5.00',
        'Celestial Corners': '€ 5.00',
        'Starlit Halo': '€ 10.00',
        'Lunar Harmony': '€ 10.00',
        'Astro Mechanics': '€ 15.00',
        'Cosmic Crown': '€ 25.00'
    };

    // Card style to ensure consistent heights
    const cardStyle = {
    };

    // Description box style to ensure equal heights
    const descriptionStyle = {
        minHeight: '60px',
    };

    return (
        <div className="w-full">
            <div className="grid !grid-cols-2 !gap-8 mt-0 md:!grid-cols-4 w-full">
                {[
                    'Stellar Simplicity',
                    'Orbit',
                    'Constellation Frame',
                    'Celestial Corners',
                    'Starlit Halo',
                    'Lunar Harmony',
                    'Astro Mechanics',
                    'Cosmic Crown'
                ].map((orbitalStyle, index) => (
                    <div key={orbitalStyle} className="flex flex-col mb-6">
                        <div
                            className={`relative cursor-pointer rounded-xl overflow-hidden transition-all hover:shadow-xl mb-3 ${formData.orbitalStyle === orbitalStyle ? 'border-accent shadow-lg' : 'border-transparent hover:bg-primary/20'}`}
                            onClick={() => handleOptionSelect('orbitalStyle', orbitalStyle)}
                            style={cardStyle}
                        >
                            <img src={`/images/product-${index + 1}.png`} className="w-full"></img>
                        </div>

                        {/* Style name, price, and select button */}
                        <div className="flex justify-between items-start">
                            <div className="flex flex-col">
                                <div className="text-[#A0A0A0] text-[14px] font-normal mt-2">
                                    {orbitalStyle.charAt(0).toUpperCase() + orbitalStyle.slice(1)}
                                </div>
                                <div className="text-white text-[20px] font-normal">
                                    {orbitalPrices[orbitalStyle]}
                                </div>
                            </div>
                            <button
                                onClick={() => handleOptionSelect('orbitalStyle', orbitalStyle)}
                                className={formData.orbitalStyle === orbitalStyle
                                    ? 'mt-2 py-2 w-[120px] rounded-full border-2 border-solid bg-accent text-primary border-accent hover:bg-accent hover:text-primary'
                                    : 'mt-2 py-2 w-[120px] rounded-full border-2 border-solid border-white/70 bg-transparent text-white hover:bg-white/10 hover:border-accent transition-colors'}
                            >
                                {formData.orbitalStyle === orbitalStyle ? 'Selected' : 'Select'}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DesignStep; 